import { render, staticRenderFns } from "./PopoverMenu.vue?vue&type=template&id=0a9e1c3e&scoped=true"
import script from "./PopoverMenu.vue?vue&type=script&lang=ts"
export * from "./PopoverMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e1c3e",
  null
  
)

export default component.exports